var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[(_vm.score)?_c('b-badge',{attrs:{"pill":"","variant":_vm.variant}},[_vm._v(_vm._s(_vm.$t(_vm.score)))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }